// @ts-nocheck
import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { dateTrim } from '@lbca-shared/helpers/formats';
import { IconComponent } from '@lbca-shared/icon';
import { v1 as uuidV1 } from 'uuid';
import { MaskCurrencyBr } from '../../../../../helpers/_old_helpers/masks/currency_br';
import { MaskCurrencyUs } from '../../../../../helpers/_old_helpers/masks/currency_us';
import { InputTextComponent } from '../../../fields/input-text/input-text.component';
import { SelectComponent } from '../../../fields/select/select.component';
import { TableComponent } from '../../../table/table.component';
import { Table } from '../../../table/table.model';
import { DynamicFormService } from '../../dynamic-form.service';
import { FormTemplateService } from '../form-template/form-template.service';
import { tableHeader } from './cco-table';

@Component({
  selector: 'lbca-cco',
  templateUrl: './cco.component.html',
  styleUrl: './cco.component.scss',
  imports: [TableComponent, SelectComponent, InputTextComponent, CurrencyPipe, IconComponent],
})
export class CcoComponent implements OnInit {
  public disabled;
  public dismemberOptions;
  public letterIdList: any[] = [];
  public totalValueRequest: any[] = [];
  public hasError;
  public artifactsConfig = {};
  public requestConfig = {};
  public optionsSelected: any[] = [];
  public errors: any = {};
  public dynamicFormService;
  public processId!: string;
  public options: any[] = [];
  public requestList: any[] = [];
  public dismemberList: any[] = [];
  public valueField: any = { type: undefined, value: undefined, id: undefined };
  public letterLabels;

  public table: Table = {
    body: [],
    columns: [],
  };

  public typeLegalRequest;

  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
  }
  public labelConfig = {};
  @Input('properties') set templateFields(properties) {
    this.artifactsConfig = properties.config?.artifacts;
    this.labelConfig = properties.config?.labelConfig;
    this.requestConfig = properties.config?.request;
  }
  @Input('dataAttr') set dataAttibutes(data) {
    this.processId = data.processNumber;
  }
  @Input('origin') set disable(value) {
    if (value === 'task-form-complete') {
      this.disabled = true;
    }
  }
  @Output('validateCallback') validateCallbackEmitter = new EventEmitter();

  constructor(
    private formTemplateService: FormTemplateService,
    public maskcurrencyBr: MaskCurrencyBr,
    private maskCurrencyUs: MaskCurrencyUs
  ) {}

  ngOnInit(): void {
    this.getlebelLetter();
    this.getLetterByProcessId();
    this.getOptionsDismember();
    this.getLabelTypeLegalRequest();
    this.validateCallbackEmitter.emit(this.validateCallbackFields);
  }

  calculateTotal(body) {
    const totalValue = body.reduce((acc, element) => {
      return acc + Number(element.updated_value);
    }, 0);
    return totalValue;
  }

  getlebelLetter() {
    const params = {
      tableName: this.labelConfig['tableName'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>('/task/drop-data', params)
      .subscribe((resp: Array<any>) => {
        this.letterLabels = resp;
      });
  }

  getLetterByProcessId() {
    const params = {
      tableName: this.artifactsConfig['tableName'],
      processId: this.processId,
      entityKey: this.artifactsConfig['entityKey'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>(this.artifactsConfig['entityRecoverUrl'], params)
      .subscribe((resp: Array<any>) => {
        if (resp.length !== 0) {
          resp.map((artifact) => {
            const payList = artifact[this.artifactsConfig['entityKey']].map((payList) => ({
              ...payList,
              referenceId: artifact.id,
              letter_type: artifact.letter_type,
            }));

            if (payList.length !== 0) {
              this.requestList.push(...payList);
            }
          });
        }
        if (this.requestList.length === 0) {
          this.dynamicFormService.unlockDynamicFormEmitter.emit(false);
        } else {
          this.dynamicFormService.unlockDynamicFormEmitter.emit(true);
        }
      });
  }

  formatLabel(letterResquest: { [key: string]: any }): string {
    const { letter_type, type_id } = letterResquest;
    const resquestLabel: string = this.getLabel(type_id, this.typeLegalRequest);
    if (letter_type) {
      const letterLabel: string = this.getLabel(letter_type, this.letterLabels);
      return `${letterLabel}/${resquestLabel}`;
    }
    return `${resquestLabel}`;
  }

  mountTable(body: Array<any>, typeId: string) {
    const payListFormatted = body.map((payList) => ({ ...payList, id: typeId }));

    payListFormatted.forEach((element) => {
      if (element.payValue || element.updated_value) {
        element.payValue = this.setMask(this.maskcurrencyBr, element.payValue);
        element.updated_value = this.setMask(this.maskcurrencyBr, element.updated_value);
      }
      if (element.payValueUS) {
        element.payValueUS = this.setMask(this.maskCurrencyUs, element.payValueUS);
      }
      if (element.id) {
        element.id = this.getLabel(typeId, this.typeLegalRequest);
      }
      if (element.reference_date) {
        element.reference_date = dateTrim(new Date(element.reference_date * 1000));
      }
    });
    this.table = {
      columns: tableHeader,
      body: payListFormatted,
    };
    return this.table;
  }

  setMask(mask: any, value: string) {
    value = mask.setMask(value, 0).formatedValue;
    return value;
  }

  getOptionsDismember() {
    const params = {
      tableName: this.requestConfig['tableName'],
    };
    this.formTemplateService
      .getDinamicUrl<Array<any>>('/task/drop-data', params)
      .subscribe((resp: Array<any>) => {
        this.dismemberOptions = resp;
      });
  }

  removeItem(id: string, arr: Array<any>) {
    const index = arr.findIndex((e) => e.id === id);
    if (index > -1) {
      arr.splice(index, 1);
    }
    this.dynamicFormService.setTimeOutToSaveData('dismemberList', this.dismemberList);
  }

  changeLabelValue(event) {
    const itemId = event.target.value;

    if (event.target.checked) {
      const item = this.requestList.filter((value) => value.id === itemId)[0];
      this.optionsSelected.push(item);
    } else {
      this.removeItem(itemId, this.optionsSelected);
    }
  }

  back() {
    this.optionsSelected = [];
    this.options = [];
    this.totalValueRequest = [];
    this.dismemberList = [];
    this.errors = [];
    this.dynamicFormService.setTimeOutToSaveData('dismemberList', undefined);
    this.dynamicFormService.setTimeOutToSaveData(this.artifactsConfig['keyList'], undefined);
    this.dynamicFormService.setTimeOutToSaveData('amount', undefined);
  }

  selectItems() {
    this.options = [...this.optionsSelected];
    const idList = this.optionsSelected.map((item) => ({
      letterId: item.referenceId,
      requestIds: [item.id],
    }));
    this.letterIdList = Object.values(
      idList.reduce((obj, item) => {
        obj[item.letterId]
          ? obj[item.letterId].requestIds.push(...item.requestIds)
          : (obj[item.letterId] = { ...item });
        return obj;
      }, {})
    );
    this.dynamicFormService.setTimeOutToSaveData(
      this.artifactsConfig['keyList'],
      this.letterIdList
    );

    this.totalValueRequest = this.optionsSelected.map(({ id, payList }) => ({
      id,
      total: this.calculateTotal(payList),
    }));

    this.dynamicFormService.setTimeOutToSaveData('amount', this.totalValueRequest);
    this.dynamicFormService.setTimeOutToSaveData('dismemberList', this.formatDismemberValue());
  }

  changeValue(event, key, opt) {
    this.optionsSelected.map((e) => {
      if (e.id === opt.id) {
        this.valueField[key] = event;
        this.valueField.id = opt.id;
      }
    });
  }

  checkValue(id: string, body: { [key: string]: string }, inputValue: string) {
    const requestValue = this.calculateTotal(body);

    const totalDismember = this.dismemberList
      .filter((e) => e.referenceId === id)
      .reduce((acc, element) => {
        return acc + Number(element.value);
      }, 0);
    const result = totalDismember + Number(inputValue);

    if (Number(inputValue) > Number(requestValue) || result > Number(requestValue) || !inputValue) {
      this.errors = ['Valor adicionado maior que o valor total de solicitações'];
      return false;
    } else {
      this.errors = [];
      return true;
    }
  }

  addField(request: { [key: string]: any }, id: string) {
    const item = {
      id: uuidV1(),
      type: this.valueField.type,
      value: this.valueField.value,
      referenceId: id,
      paymentIds: request['payList'].map((payList) => ({ paymentId: payList.id })),
    };
    const payListFormatted = request['payList'].map((payList) => ({
      ...payList,
      id: request['id'],
    }));
    if (this.checkValue(id, payListFormatted, this.valueField.value)) {
      this.dismemberList.push(item);
      request['dismember'] = this.dismemberList;
      // this.dynamicFormService.setTimeOutToSaveData('dismemberList', this.dismemberList);
      this.dynamicFormService.setTimeOutToSaveData('dismemberList', this.formatDismemberValue());
    }
  }

  getLabel(id: string, arr: Array<any>) {
    if (!arr) return;
    const item = arr.filter((e) => e.id === id);
    return item[0].label;
  }

  getLabelTypeLegalRequest() {
    const params = {
      context: this.requestConfig['context'],
      parent: 0,
    };
    this.formTemplateService
      .getDinamicUrl(this.requestConfig['entityRecoverUrl'], params)
      .subscribe((resp) => {
        this.typeLegalRequest = resp;
      });
  }

  toggleInputs(selected) {
    selected.show = !selected.show;
  }

  public validateCallbackFields = () => {
    this.hasError = false;
    if (!this.letterIdList || this.letterIdList.length === 0) {
      this.hasError = true;
    }
    return this.hasError;
  };

  formatDismemberValue() {
    const valueToSave = this.options.map((op) => ({
      referenceId: op.id,
      paymentIds: op.payList.map((pay) => ({ paymentId: pay.id })),
      dismemberments: op.dismember
        ? op.dismember.map((dis) => ({
            id: dis.id,
            value: dis.value,
            type: dis.type,
          }))
        : [],
    }));

    return valueToSave;
  }
}
